import { Label } from "expano-components";

const ProgressStatus = ({ status }) => {
  switch (status) {
    case "pending":
      return <Label type="fill" text="Oczekuje" color="#a2a5b9" />;
    case "specification":
      return <Label type="fill" text="Katalogowanie" color="#a2a5b9" />;
    case "images":
      return <Label type="fill" text="Grafika" color="#a2a5b9" />;
    case "category":
      return <Label type="fill" text="Kategoria" color="#a2a5b9" />;
    case "content":
      return <Label type="fill" text="Content" color="#a2a5b9" />;
    case "to_export":
      return <Label type="fill" text="Deployment" color="#a2a5b9" />;
    case "done":
      return <Label type="fill" text="Zakończone" color="#a2a5b9" />;
    default:
      return status;
  }
};

export default ProgressStatus;
